export default "__VITE_ASSET__86rjvHB3__"